import { ApolloClient, HttpLink } from '@apollo/client';
import { InMemoryCache } from '@apollo/client/cache';

import headersLink from './headersLink';

let client;

const initClient = () => {
  client = new ApolloClient({
    link: headersLink.concat(
      new HttpLink({
        uri: '/marketplace/graphql',
        credentials: 'same-origin'
      })
    ),
    cache: new InMemoryCache({
      addTypename: false
    })
  });

  return client;
};

export default () => client || initClient();
